<app-general-search-input
  [title]="title | translate"
  [expanded]="selection.hasValue()"
>
  <ng-template>
    <form [formGroup]="group" class="easy-form">
      <div *ngFor="let option of data?.checkboxOptions; let idx = index">
        <mat-form-field>
          <app-easy-checkbox
            [formControlName]="option"
            [id]="option"
            (ngModelChange)="valueChanged($event, data.optionIds?.[idx] ?? option)"
            [label]="
              (data.optionTitlePrefix ?? '') +
                (data.optionTitlePrefix ? option.toUpperCase() : option)
                | translate
            "
            color="white"
          ></app-easy-checkbox>
        </mat-form-field>
      </div>
    </form>
  </ng-template>
</app-general-search-input>
